export default "__VITE_ASSET__C6xSRHs1__"